import React from 'react'

import { EmptyState } from 'app/ProfileRevampPage/components/EmptyState'
import { ProfileResponsiveSheet } from 'app/ProfileRevampPage/components/ProfileResponsiveSheet'

interface IEditPersonalDataDrawerProps {
  isOpen: boolean
  onClose: () => void
  onCloseButtonClicked: () => void
}

export const EditPersonalDataDrawer = ({
  isOpen,
  onClose,
  onCloseButtonClicked,
}: IEditPersonalDataDrawerProps) => {
  return (
    <ProfileResponsiveSheet
      isOpen={isOpen}
      onClose={onClose}
      onCloseButtonClicked={onCloseButtonClicked}
      title="Edit data pribadi"
    >
      <div className="p-4">
        <EmptyState
          imageSrc="/icon/typing-monitor.png"
          imgWidth="84px"
          imgHeight="84px"
          description="Untuk mengubah data pribadi, harap hubungi koordinator sekolah untuk membantu Anda."
        />
      </div>
    </ProfileResponsiveSheet>
  )
}
